﻿//Components
import { WizardButtons } from '../../Wizard/WizardButtons';
import { Alert } from '@mui/material';
//Styles
import './ownershipStyles.css';

const ConfirmOwnershipChange = (props) => {
  const completeHandlerLocal = () => {
    props.completedHandler();
  };

  return (
    <>
      <Alert severity="success">
        An Ownership change packet has been sent to you. Please complete the packet at your earliest
        convenience to expedite your Ownership change.
      </Alert>

      <WizardButtons {...props} completedHandler={completeHandlerLocal} />
    </>
  );
};

export { ConfirmOwnershipChange };
